/**
 * Add app icons to the template cache so they may be referenced from apps.json
 */
export const GRID_IMAGES_CACHE_PREFIX = 'gazelle/grid/images/';
export default function cacheAccountIcons($templateCache) {
  'ngInject';

  // (Use the html loader to pull the SVG content directly into the template cache.)
  const requireImages = require.context('!html!./images', true, /\.svg$/);

  _.forEach(requireImages.keys(), img => {
    // strip off leading ./
    let imgFileName = img.substr(2);
    $templateCache.put(GRID_IMAGES_CACHE_PREFIX + imgFileName, requireImages(img));
  });
}



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/extensions/grid/cache-images.run.js